import { NgModule } from '@angular/core';
import { LoaddingComponent } from './loadding.component';
import { MatCardModule, } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';


@NgModule({
  declarations: [
    LoaddingComponent
  ],
  imports: [
    MatProgressBarModule,
    MatCardModule,
  ],
  exports: [
    LoaddingComponent
  ]
})
export class LoaddingModule { }
